// src/pages/ReturnPolicyPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ReturnPolicyPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const SectionTitle = ({ children }) => (
    <h2 className="text-xl font-black text-[#0F2F63] mt-8 mb-4 border-b border-gray-100 pb-2">
      {children}
    </h2>
  );

  const BulletPoint = ({ children }) => (
    <li className="flex items-start mb-2.5">
      <span className="text-[#FF7A59] mr-3 mt-1.5"><i className="fas fa-circle text-[6px]"></i></span>
      <span className="text-gray-600 font-medium leading-relaxed flex-1">{children}</span>
    </li>
  );

  return (
    <div className="py-6 px-4 md:px-8 max-w-4xl mx-auto w-full min-h-[70vh] animate-fade-in">
      <div className="flex items-center gap-4 mb-6 border-b border-gray-100 pb-5">
        <button 
          onClick={() => navigate(-1)} 
          className="w-10 h-10 rounded-full bg-white shadow-sm border border-gray-200 hover:bg-gray-50 flex items-center justify-center text-gray-600 transition-colors"
        >
          <i className="fas fa-arrow-left"></i>
        </button>
        <h1 className="text-2xl md:text-3xl font-black text-[#0F2F63] flex items-center gap-3">
          <i className="fas fa-undo-alt text-[#FF7A59]"></i> Return Policy
        </h1>
      </div>

      <div className="bg-white p-6 md:p-10 rounded-3xl shadow-sm border border-gray-100">
        <SectionTitle>1. General Return Conditions</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          At SV MART, we strive to ensure you receive the best quality products. If you are not satisfied with your order, our return policy is designed to be simple and hassle-free.
        </p>
        <ul className="mb-4">
          <BulletPoint>Items must be returned in their original packaging, unopened, and unused.</BulletPoint>
          <BulletPoint>Return requests must be raised within the stipulated timeframe for the specific product category.</BulletPoint>
          <BulletPoint>Proof of purchase (invoice or order ID) is mandatory for processing returns.</BulletPoint>
        </ul>

        <SectionTitle>2. Category-Specific Policies</SectionTitle>
        <ul className="mb-4">
          <BulletPoint><strong className="text-gray-800">Perishables (Fresh Fruits, Veggies, Dairy):</strong> Must be reported at the time of delivery or within 2 hours of receiving the order. Due to hygiene reasons, we cannot accept returns on opened perishable items unless spoiled upon delivery.</BulletPoint>
          <BulletPoint><strong className="text-gray-800">Packaged Groceries:</strong> Can be returned within 3 days of delivery if the seal is unbroken and the product is not expired.</BulletPoint>
          <BulletPoint><strong className="text-gray-800">Electronics & Home Needs:</strong> Eligible for return or replacement within 7 days in case of manufacturing defects.</BulletPoint>
        </ul>

        <SectionTitle>3. Refund Process</SectionTitle>
        <ul className="mb-4">
          <BulletPoint>Once your return is picked up and verified, refunds will be initiated within 24 hours.</BulletPoint>
          <BulletPoint>Online payments will be credited back to the original payment source (Credit/Debit Card, UPI, Wallets) within 5-7 business days.</BulletPoint>
          <BulletPoint>For Cash on Delivery (COD) orders, the refund will be provided as SV Mart Wallet balance or transferred to your provided bank account.</BulletPoint>
        </ul>
      </div>
    </div>
  );
};

export default ReturnPolicyPage;